export const StoreIcon = () => {
    return (
        <svg
            width="23"
            height="20"
            viewBox="0 0 23 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.25 0H1.25V2.5H21.25V0ZM22.5 12.5V10L21.25 3.75H1.25L0 10V12.5H1.25V20H13.75V12.5H18.75V20H21.25V12.5H22.5ZM11.25 17.5H3.75V12.5H11.25V17.5Z"
                fill="currentColor"
            />
        </svg>
    );
};
